export default function genererParution() {
  return {
    code: '',
    numParution: 0,
    nomParution: '',
    dateEnvoiCF: null,
    dateEnvoiBAT: null,
    dateRemiseEltTech: new Date(),
    dateParution: new Date(),
    pages: [],
    societeId: null,
    produitId: null,
    actif: true,
  };
}
